import React from "react";
import { Table, Tag, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import LinkButton from "../../../components/LinkButton";
import { useGetOdReviewRunsQuery } from "../../../store/api/odReviewApi";
import type {
  OdReviewRunStatus,
  OdReviewRunSummary,
} from "../../../services/odReview/odReview.types";
import RunCounters from "./RunCounters";
import { OD_REVIEW_PHASE_LABELS } from "./RunLauncher.utils";

const { Text } = Typography;

const STATUS_TAGS: Record<OdReviewRunStatus, { color: string; label: string }> = {
  PENDING: { color: "default", label: "Pendiente" },
  IN_PROGRESS: { color: "blue", label: "En progreso" },
  COMPLETED: { color: "green", label: "Completada" },
  FAILED: { color: "red", label: "Falló" },
};

const columns: ColumnsType<OdReviewRunSummary> = [
  { title: "ID", dataIndex: "id", key: "id", width: 80 },
  {
    title: "Estado",
    dataIndex: "status",
    key: "status",
    render: (status: OdReviewRunStatus) => {
      const tag = STATUS_TAGS[status];
      return <Tag color={tag.color}>{tag.label}</Tag>;
    },
  },
  {
    title: "Progreso",
    key: "progress",
    render: (_, run) => `${run.reviewed_activities} de ${run.total_activities}`,
  },
  {
    title: "Errores encontrados",
    dataIndex: "issues_found",
    key: "issues_found",
  },
  {
    title: "Alcance",
    key: "phases",
    render: (_, run) => (
      <>
        {(run.phases ?? []).map((phase) => (
          <Tag key={phase}>{OD_REVIEW_PHASE_LABELS[phase]}</Tag>
        ))}
      </>
    ),
  },
  {
    title: "Cobertura",
    key: "counters",
    render: (_, run) => <RunCounters run={run} />,
  },
  {
    title: "Creada",
    dataIndex: "created_at",
    key: "created_at",
    render: (value: string) => new Date(value).toLocaleString("es-MX"),
  },
  {
    title: "Acciones",
    key: "actions",
    render: (_, run) => (
      <LinkButton to={`/revision-ods/${run.id}`} type="primary">
        Ver revisión
      </LinkButton>
    ),
  },
];

const RunsList: React.FC = () => {
  const { data: runs = [], isLoading } = useGetOdReviewRunsQuery();

  return (
    <div>
      <Text strong style={{ display: "block", marginBottom: 12 }}>
        Corridas anteriores
      </Text>
      <Table
        dataSource={runs}
        columns={columns}
        rowKey="id"
        loading={isLoading}
        locale={{ emptyText: "Todavía no se corrió ninguna revisión." }}
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: ["10", "20", "50"],
          showSizeChanger: true,
        }}
      />
    </div>
  );
};

export default RunsList;
